import React, { useCallback, useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import CloseButton from './common/CloseButton';

const TermsAndConditions = ({ show, setShow, setAgree }) => {
    const [terms, setTerms] = useState('');
    const handleClose = () => {
        setShow(false);
        setAgree(false);
    };

    const handleAgree = () => {
        setShow(false);
        setAgree(true);
    };

    const cancelTokenSource = useRef();

    const cancelRequest = useCallback(() => {
        if (cancelTokenSource.current) {
            cancelTokenSource.current.cancel('Abort terms and conditions request');
        }
    }, []);

    useEffect(() => {
        let isMounted = true;

        if(isMounted) {
            const source = axios.CancelToken.source();
            cancelTokenSource.current = source;

            axios.get('/api/terms-and-conditions', {
                cancelToken: cancelTokenSource.current.token
            })
            .then((res) => {
                setTerms(res.data.content);
            }).catch(error => {
                if (axios.isCancel(error)) {
                    console.log('Terms and conditions request canceled', error.message);
                }
            })
        }

        return () => {
            cancelRequest();
            isMounted = false;
        }
    }, []);

    return (
        <Modal
            show={show}
            onHide={handleClose}
            keyboard={false}
            size="xl"
            scrollable
        >
            <Modal.Body className="termsAndConditions">
                <CloseButton
                    className="close"
                    onClick={handleClose}
                    style={{ position: 'absolute', top: '12px', right: '12px' }}
                />
                <div dangerouslySetInnerHTML={{ __html: terms }} className="p-4"></div>
                <div className="text-center mb-5">
                    <Button
                        variant="primary"
                        onClick={handleAgree}
                        className="btn btn-primary btn-agree"
                    >I Agree</Button>
                    {' '}
                    <Button
                        variant="link"
                        onClick={handleClose}
                        className="btn btn-primary btn-disagree"
                    >I Disagree</Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default TermsAndConditions;
